var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { FormSectionVariant, } from '../../../interfaces/createApplication';
import { buildConfiguredFields, normaliseConfigKey, readVendorConfigSections, toConfiguredOptions, toConfiguredSectionId, } from './field_config_schema';
var toEntryKey = function (entry) { var _a, _b; return normaliseConfigKey((_b = (_a = entry === null || entry === void 0 ? void 0 : entry.apiFieldName) !== null && _a !== void 0 ? _a : entry === null || entry === void 0 ? void 0 : entry.name) !== null && _b !== void 0 ? _b : ''); };
var indexVendorFieldConfig = function (fieldConfig) {
    var bySection = new Map();
    var byFieldName = new Map();
    if (!fieldConfig) {
        return { bySection: bySection, byFieldName: byFieldName };
    }
    Object.keys(fieldConfig).forEach(function (groupName) {
        var _a;
        var sections = (_a = fieldConfig[groupName]) === null || _a === void 0 ? void 0 : _a.sections;
        if (!sections) {
            return;
        }
        Object.keys(sections).forEach(function (sectionName) {
            var _a;
            var entries = sections[sectionName];
            if (!Array.isArray(entries)) {
                return;
            }
            var sectionKey = normaliseConfigKey(sectionName);
            var sectionEntries = (_a = bySection.get(sectionKey)) !== null && _a !== void 0 ? _a : new Map();
            entries.forEach(function (entry) {
                var key = toEntryKey(entry);
                if (!key) {
                    return;
                }
                if (!sectionEntries.has(key)) {
                    sectionEntries.set(key, entry);
                }
                byFieldName.set(key, entry);
            });
            bySection.set(sectionKey, sectionEntries);
        });
    });
    return { bySection: bySection, byFieldName: byFieldName };
};
var findEntry = function (configIndex, sectionEntries, field) {
    var _a, _b, _c, _d;
    var apiKey = normaliseConfigKey((_a = field.apiFieldName) !== null && _a !== void 0 ? _a : '');
    var nameKey = normaliseConfigKey(field.name);
    return ((_d = (_c = (_b = (apiKey ? sectionEntries === null || sectionEntries === void 0 ? void 0 : sectionEntries.get(apiKey) : undefined)) !== null && _b !== void 0 ? _b : sectionEntries === null || sectionEntries === void 0 ? void 0 : sectionEntries.get(nameKey)) !== null && _c !== void 0 ? _c : (apiKey ? configIndex.byFieldName.get(apiKey) : undefined)) !== null && _d !== void 0 ? _d : configIndex.byFieldName.get(nameKey));
};
var applyEntryToField = function (field, entry) {
    var _a, _b, _c;
    var overriddenField = __assign({}, field);
    if (typeof entry.required === 'boolean' && field.isMandatory !== false) {
        overriddenField.isMandatory = entry.required;
    }
    if (entry.disabled === true || entry.isEditable === false) {
        overriddenField.isDisabled = function () { return true; };
    }
    if (entry.name) {
        overriddenField.label = entry.name;
    }
    if (entry.placeholder) {
        overriddenField.placeholder = entry.placeholder;
    }
    var tooltip = String((_a = entry.toolTipMsg) !== null && _a !== void 0 ? _a : '').trim();
    if (tooltip) {
        overriddenField.tooltip = tooltip;
    }
    var startAdornment = String((_b = entry.startAdornment) !== null && _b !== void 0 ? _b : '').trim();
    if (startAdornment) {
        overriddenField.startAdornment = startAdornment;
    }
    var maxLength = Number((_c = entry.maxLength) !== null && _c !== void 0 ? _c : 0);
    if (maxLength > 0 && !field.format) {
        overriddenField.maxLength = maxLength;
    }
    if (entry.defaultValue !== undefined) {
        overriddenField.defaultValue = entry.defaultValue;
    }
    var configuredOptions = toConfiguredOptions(entry);
    if (configuredOptions && configuredOptions.length > 0) {
        overriddenField.options = configuredOptions;
        overriddenField.getOptions = undefined;
    }
    return overriddenField;
};
var applyToGroup = function (group, configIndex, sectionEntries) {
    var fields = group.fields.reduce(function (keptFields, field) {
        var entry = findEntry(configIndex, sectionEntries, field);
        if ((entry === null || entry === void 0 ? void 0 : entry.hideField) === true) {
            return keptFields;
        }
        keptFields.push(entry ? applyEntryToField(field, entry) : field);
        return keptFields;
    }, []);
    return fields.length > 0 ? __assign(__assign({}, group), { fields: fields }) : null;
};
export var applyVendorFieldConfig = function (sections, fieldConfig) {
    var configIndex = indexVendorFieldConfig(fieldConfig);
    if (configIndex.byFieldName.size === 0) {
        return sections;
    }
    return sections.reduce(function (keptSections, section) {
        var _a, _b;
        var sectionEntries = (_a = configIndex.bySection.get(normaliseConfigKey(section.id))) !== null && _a !== void 0 ? _a : configIndex.bySection.get(normaliseConfigKey((_b = section.title) !== null && _b !== void 0 ? _b : ''));
        var groups = section.groups.reduce(function (keptGroups, group) {
            var appliedGroup = applyToGroup(group, configIndex, sectionEntries);
            if (appliedGroup) {
                keptGroups.push(appliedGroup);
            }
            return keptGroups;
        }, []);
        if (groups.length > 0) {
            keptSections.push(__assign(__assign({}, section), { groups: groups }));
        }
        return keptSections;
    }, []);
};
var toMergeTarget = function (source) {
    var indexesByKey = new Map();
    source.entries.forEach(function (entry, entryIndex) {
        var _a;
        var key = toEntryKey(entry);
        if (!key) {
            return;
        }
        indexesByKey.set(key, ((_a = indexesByKey.get(key)) !== null && _a !== void 0 ? _a : []).concat(entryIndex));
    });
    return {
        source: source,
        sectionId: toConfiguredSectionId(source.groupKey, source.sectionName),
        unplacedIndexes: new Set(source.entries.map(function (_entry, index) { return index; })),
        indexesByKey: indexesByKey,
    };
};
var takeEntry = function (target, field) {
    var _a, _b;
    var candidateKeys = [
        normaliseConfigKey((_a = field.apiFieldName) !== null && _a !== void 0 ? _a : ''),
        normaliseConfigKey(field.name),
    ].filter(Boolean);
    for (var keyIndex = 0; keyIndex < candidateKeys.length; keyIndex += 1) {
        var entryIndexes = (_b = target.indexesByKey.get(candidateKeys[keyIndex])) !== null && _b !== void 0 ? _b : [];
        var freeIndex = entryIndexes.find(function (index) { return target.unplacedIndexes.has(index); });
        if (freeIndex !== undefined) {
            target.unplacedIndexes.delete(freeIndex);
            return target.source.entries[freeIndex];
        }
    }
    return undefined;
};
var readEntryAnywhere = function (targets, field) {
    var _a;
    var key = normaliseConfigKey((_a = field.apiFieldName) !== null && _a !== void 0 ? _a : '');
    if (!key) {
        return undefined;
    }
    for (var targetIndex = 0; targetIndex < targets.length; targetIndex += 1) {
        var entryIndexes = targets[targetIndex].indexesByKey.get(key);
        if (entryIndexes && entryIndexes.length > 0) {
            return targets[targetIndex].source.entries[entryIndexes[0]];
        }
    }
    return undefined;
};
var resolveTarget = function (targetsByKey, declaredSection) {
    var _a;
    var fallbackNames = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        fallbackNames[_i - 2] = arguments[_i];
    }
    if (declaredSection !== undefined) {
        var declaredKey = normaliseConfigKey(declaredSection);
        return declaredKey ? targetsByKey.get(declaredKey) : undefined;
    }
    for (var nameIndex = 0; nameIndex < fallbackNames.length; nameIndex += 1) {
        var key = normaliseConfigKey((_a = fallbackNames[nameIndex]) !== null && _a !== void 0 ? _a : '');
        var target = key ? targetsByKey.get(key) : undefined;
        if (target) {
            return target;
        }
    }
    return undefined;
};
export var hasConfigSectionMapping = function (sections) {
    return sections.some(function (section) {
        return section.configSection !== undefined ||
            section.groups.some(function (group) { return group.configSection !== undefined; });
    });
};
export var mergeVendorFieldConfigIntoLayout = function (layoutSections, fieldConfig, buildOptions) {
    if (buildOptions === void 0) { buildOptions = {}; }
    var targets = readVendorConfigSections(fieldConfig).map(toMergeTarget);
    if (targets.length === 0) {
        return layoutSections;
    }
    var targetsByKey = new Map();
    targets.forEach(function (target) {
        var key = normaliseConfigKey(target.source.sectionName);
        if (key && !targetsByKey.has(key)) {
            targetsByKey.set(key, target);
        }
    });
    var mergedSections = layoutSections.map(function (section, sectionIndex) {
        var sectionTarget = resolveTarget(targetsByKey, section.configSection, section.id, section.title);
        var groups = section.groups.map(function (group, groupIndex) {
            var target = group.configSection !== undefined
                ? resolveTarget(targetsByKey, group.configSection)
                : sectionTarget;
            var isDesignOnlyGroup = group.configSection === '';
            var keepsUnconfiguredFields = !buildOptions.isConfigAuthoritative || isDesignOnlyGroup;
            var fields = [];
            var hasPlacedField = false;
            group.fields.forEach(function (field) {
                var entry = target
                    ? takeEntry(target, field)
                    : readEntryAnywhere(targets, field);
                if (!entry) {
                    if (keepsUnconfiguredFields || field.isDesignOwned) {
                        fields.push(field);
                    }
                    return;
                }
                if (target) {
                    hasPlacedField = true;
                }
                if (entry.hideField === true) {
                    return;
                }
                fields.push(applyEntryToField(field, entry));
            });
            if (target && hasPlacedField && !target.claim) {
                target.claim = { sectionIndex: sectionIndex, groupIndex: groupIndex };
            }
            return { group: group, fields: fields };
        });
        return { section: section, groups: groups };
    });
    targets.forEach(function (target) {
        var _a;
        if (!target.claim || target.unplacedIndexes.size === 0) {
            return;
        }
        var entries = Array.from(target.unplacedIndexes)
            .sort(function (left, right) { return left - right; })
            .map(function (index) { return target.source.entries[index]; });
        target.unplacedIndexes.clear();
        var extraFields = buildConfiguredFields(entries, target.sectionId, { groupKey: target.source.groupKey, sectionKey: target.source.sectionName }, buildOptions);
        if (extraFields.length > 0) {
            var _b = target.claim, sectionIndex = _b.sectionIndex, groupIndex = _b.groupIndex;
            (_a = mergedSections[sectionIndex].groups[groupIndex].fields).push.apply(_a, extraFields);
        }
    });
    var sections = mergedSections.reduce(function (keptSections, merged) {
        var groups = merged.groups.reduce(function (keptGroups, mergedGroup) {
            if (mergedGroup.fields.length > 0) {
                keptGroups.push(__assign(__assign({}, mergedGroup.group), { fields: mergedGroup.fields }));
            }
            return keptGroups;
        }, []);
        if (groups.length > 0) {
            keptSections.push(__assign(__assign({}, merged.section), { groups: groups }));
        }
        return keptSections;
    }, []);
    targets.forEach(function (target) {
        if (target.claim) {
            return;
        }
        var fields = buildConfiguredFields(target.source.entries, target.sectionId, { groupKey: target.source.groupKey, sectionKey: target.source.sectionName }, buildOptions);
        if (fields.length === 0) {
            return;
        }
        sections.push({
            id: target.sectionId,
            title: target.source.sectionName,
            variant: FormSectionVariant.Filled,
            groups: [{ id: target.sectionId + '-group', fields: fields }],
        });
    });
    return sections;
};
